import { AnticipatedMonthlyActivity } from 'commons/types/DTO/commons'

import { AnticipatedMonthlyActivityFormValue } from '../../../../types/forms'

export const mapAnticipatedMonthlyActivityForm = (
  formValues: AnticipatedMonthlyActivityFormValue
): AnticipatedMonthlyActivity => ({
  ...formValues
})
